module.exports = __webpack_public_path__ + "static/logo_white_pink-c351aac26d4508d922d16043f002f0ef.png";